import PropTypes from '@userzoomlibraries/toolkit-js-utils/prop-types';

/**
 * @license
 * This source code is and remains the property of UserZoom Technologies Inc (sucursal en España).
 * Dissemination of this information or reproduction of this material is strictly
 * forbidden unless prior written permission is obtained from
 * UserZoom Technologies Inc (sucursal en España) (https://www.userzoom.com).
 */
/**
 * Get the base styles of a theme.
 *
 * @function
 * @param {object} [parameter={}] - Object with 'props'.
 * @param {object} [parameter.props={}] - Props of the component.
 * @returns {string} Returns the base styles of a theme.
 * @example
 * getBaseByProps({ props });
 * // => 'h1 { ... }'
 */

var getBaseByProps = function getBaseByProps() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$props = _ref.props,
      props = _ref$props === void 0 ? {} : _ref$props;

  var base = props.theme.base;
  return base;
};

getBaseByProps.HELPER_ID = 'Gearz.ThemeManager.getBaseByProps';
getBaseByProps.returnType = PropTypes.oneOfTypeWithDescription([PropTypes.string, PropTypes.arrayOf(PropTypes.string), PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.string)) // needed for css method of styled-components
], 'styled-component CSS object with the base styles.');
getBaseByProps.parameterTypes = {
  parameter: PropTypes.shapeWithDescription({
    props: PropTypes.objectWithDescription('Props of the component.')
  }, 'Object with the props of the component.')
};
getBaseByProps.defaultParameters = {
  parameter: {
    props: {}
  }
};

export { getBaseByProps as default };
